// @ts-check
// src/lib/relogin-context.js
// 2026-09-01 (фаза3 П2, свод P5) — модульный колбэк-регистр для входа-в-модалке.
//
// Зачем отдельный модуль вместо пропа: SessionExpiredGate рендерится в App() (родителе),
// а completeLogin живёт в AppInner (ребёнке) — Gate нельзя поднять внутрь AppInner (там
// шесть ранних return'ов — см. App.jsx), а completeLogin нельзя поднять наружу (нужны его
// setState). Тот же паттерн, что событийная шина SESSION_*_EVENT в session-expiry.js:
// плоский модульный синглтон вместо прокидывания колбэка через дерево компонентов.
//
// Жизненный цикл: AppInner регистрирует контекст в useEffect, пока пользователь залогинен
// (deps на user?.email), и снимает его при логауте/размонтировании. Пока контекста нет,
// SessionExpiredDialog показывает старый Refresh-only вид — предзаполнить форму нечем, и
// показывать её незачем (регресс для этого сценария исключён по конструкции, не тестом).
//
// Без React: плоский module-level синглтон, null по умолчанию.

/** @type {{email: string, onRelogin: (user: object, token?: object) => void} | null} */
let context = null;

/**
 * @param {{email: string, onRelogin: (user: object, token?: object) => void}} ctx
 * @returns {void}
 */
export function setReloginContext(ctx) {
  context = ctx;
}

/** @returns {void} */
export function clearReloginContext() {
  context = null;
}

/** @returns {{email: string, onRelogin: (user: object, token?: object) => void} | null} */
export function getReloginContext() {
  return context;
}
